

















import { Vue, Component, Watch, Prop } from "@/shared/vuepack";
import VS2 from "vue-script2";

Vue.use(VS2);

@Component
export default class ConsumerChatScript extends Vue {
    @Prop()
    shouldShow: boolean;
    @Prop()
    name: string;
    @Prop()
    email: string;
    @Prop()
    phone: string;
    @Prop()
    hashkey: string;

    @Watch("shouldShow")
  onShouldShowChange () {
    if (!this.shouldShow) {
    const chatWindow = document.getElementById("fn-chat-iframe-container");
    chatWindow.remove();
    }
  }
}
